// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewNotAuthorized_wrapper__N-uK9","section":"ViewNotAuthorized_section__9+8mj"};